  <div class="modal fade backdrop" id="modal-container-agreement" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        ×
                    </button>
                    <h2>
                        Service agreement
                    </h2>
                </div>
                <div class="modal-body">
                    <h3>Ownership</h3>

                    <p>Qunote is a browser-based software system for the efficient management of patients receiving clinical care.&nbsp; The Qunote system is wholly owned by The Bubblegate Company Limited (Bubblegate, We, Us) of Cage Farm Studio, Stowting Hill, Stowting, Kent TN25 6BE.&nbsp; The system is a hosted, managed platform which is leased to users on a monthly basis and any use of the system by a user during a month will incur a monthly charge.&nbsp; Users of the system have no proprietary rights over the system other than the right to use it according to the Qunote Terms and Conditions, however users will retain all rights to their digital content which they may download at any time.</p>

                    <h3>Pricing</h3>

                    <p>The cost of the system is based on user licences, and a fee will be charged in respect of each user registered and using the system during each month (active users). Where the number of users from one organisation ‘tip’ over into the next pricing band, the organisation will automatically be charged at the lower rate for all their users.&nbsp; Therefore the cost of 10 users per month will be £167, which is the same cost as 11 users.&nbsp; All the prices quoted are subject to VAT.</p>
                    <div class="table-responsive">
                      <table class="table table-hover">
                          <thead>
                            <tr>
                              <th>Number of users</th>
                              <th>Monthly fee per user</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1-10 users</td>
                              <td>£16.70</td>
                            </tr>
                            <tr>
                              <td>11-20 users</td>
                              <td>£15.18</td>
                            </tr>
                            <tr>
                              <td>21-30 users</td>
                              <td>£14.46</td>
                            </tr>
                            <tr>
                              <td>31-40 users</td>
                              <td>£13.99</td>
                            </tr>
                            <tr>
                              <td>41-50 users</td>
                              <td>£13.65</td>
                            </tr>
                            <tr>
                              <td>50+ users</td>
                              <td>£13.38</td>
                            </tr>

                          </tbody>
                      </table>
                  </div>

                    <p>Invoices are issued by email at the beginning of each month based on the number of users on the system during the preceding month.&nbsp; Payment must be made by BACS by the end of the month during which the invoices are issued.</p>

                    <h3>Storage Fees</h3>

                    <p>Each subscribing organisation is allocated a server space allowance of 200Mb for each active user and it follows that the total server space allowance of each subscribing organisation may vary according to the number of active users in a particular month.&nbsp; Where the server space required exceeds this ‘user allowance a charge will be levied according to the amount of additional space required, calculated as a total of the uploads plus a notional size of 0.15KB for each filenote. For each Gb or part of a Gb used a charge of £3.00 plus VAT will be levied and payable with the user fee.</p>

                    <h3>Service Level Guarantee</h3>

                    <p>The Qunote system runs on a 24/7/265 basis and the hosting provider offers a 100% Network uptime guarantee. From time to time it may be necessary to perform scheduled servicing or install upgrades to the system and in such cases the necessary work will be undertaken during a quiet period, outside of normal business hours, or overnight.&nbsp; In such cases, Qunote will always give notice of the outage by posting a notice on the system and by email.</p>

                    <p>Help on the functionality of the system may be obtained directly from Qunote on 01303 863818 between 9am and 5.30pm, Monday to Friday except for Bank Holidays. The office is closed from lunchtime on Christmas Eve until the New Year.</p>

                    <h3>Security</h3>

                    <p>The system is hosted on a dedicated server hosted at a secure server centre provided by Catalyst2 and located at Telehouse in Docklands. &nbsp;Telehouse is one of the UK’s premier hosting facilities, protected by its own compound, 24 hour manned security, CCTV and access only by named personnel. Data is backed up daily to a separate server cluster and data is retained for a period of 7 days.&nbsp; The hosting network is protected by two high-performance firewalls working in tandem.</p>

                    <p>&nbsp;</p>

                    <p>Communication with the site is encrypted by a 256Bit Secure Socket Later (SSL) and user access is protected by a triple-level entry system: &nbsp;username, password and three randomly selected digits from the users’ six- digit passcode.</p>

                    <p>Qunote has undertaken a security risk analysis and has implemented information security controls identified in ISO 27002. &nbsp;We are mindful of the&nbsp;evolving nature of information security threats, vulnerabilities and impacts, and we constantly assess our use of information security controls.</p>

                    <p>Qunote complies with the requirements of the Data Protection Act and take extraordinary steps to protect the data on our servers however we offer no guarantee as to the security or safeguarding of the data and clients are required to maintain their own back up of their data.&nbsp;</p>

                    <h3>Accessibility</h3>

                    <p>Qunote complies with the guidelines set out in the Web Content Accessibility Guidelines (WCAG) 2.0.</p>
                    <br />
                    <div class="well">
                        <h4>
                            Qunote is a trading name of The Bubblegate Company Limited.
                        </h4>
                        <p>
                            <strong>Registered office: </strong>Cage Farm Studio, Stowting Hill, Stowting, Kent TN25 6BE
                            <br />
                            <strong>Registered No: </strong>03662705
                            <br />
                            <strong>Tel: </strong>01303 863816
                            <br />
                            <strong>Fax: </strong>01303 863820
                            <br />
                            <strong>Email: </strong><a href="mailto:enquiries@qunote.com">enquiries&#64;qunote.com</a>
                            <br />
                            <strong>Web:</strong> <a href="https://www.qunote.com">www.qunote.com</a>
                        </p>

                    </div>
                </div>
                <div class="modal-footer">
                    <small>Last updated September 2017&nbsp;&nbsp;&nbsp;</small>

                    <a type="button" class="btn btn-default btn-xs" data-dismiss="modal">
                        Close
                    </a>
                </div>
            </div>

        </div>
    </div>
    <!-- Contact modal content -->
    <div class="modal fade backdrop" id="modal-container-contact" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        ×
                    </button>
                    <h2>
                        Contact and support
                    </h2>
                </div>
                <div class="modal-body">
                <h3>Contact details</h3>
                <p><strong>Phone:&nbsp;</strong><a href="tel:+441303863816">+44 (0)1303 863816</a></p>
                <p><strong>Email:</strong>&nbsp;<a href="mailto:info@qunote.com">info&#64;qunote.com</a></p>
                <p><strong>Address:</strong>&nbsp;Qunote, Cage Farm Studio, Stowting Hill, Stowting, Kent, TN25 6BE</p>
                <hr>
                <h3>Customer support</h3>
                <p>We like to think that using Qunote is easy, but if you're ever struggling we are here to help.</p>
                <p>Please visit <a href="https://www.qunote.com/support" target="_blank">our support pages</a> for information and downloads to help you using Qunote.</p>
                <p>Alternatively, technical support is free with your Qunote subscription, and we're available on the phone or by email  from 9:00-5:30 every weekday (apart from between Christmas and New Year).</p>
                <p>Call us on <a href="tel:+441303863816">+44 (0)1303 863816</a> or email <a href="mailto:info@qunote.com">info&#64;qunote.com</a></p>

                </div>
                <div class="modal-footer">
                    <small>Last updated September 2017&nbsp;&nbsp;&nbsp;</small>

                    <a type="button" class="btn btn-default btn-xs" data-dismiss="modal">
                        Close
                    </a>
                </div>
            </div>
        </div>
    </div>